import { Bitcoin, Wallet } from "lucide-react";
import "./clients.scss";
import { useNavigate } from "react-router-dom";
import CardListHorizontal from "../../../components/card-list-horizontal";
import { useAppDispatch, useAppSelector } from "../../../features/helpers";
import { fetchClientsByOrganization, getClientList } from "../../../store/UserSlice";
import { useEffect } from "react";
import { getStorageData } from "../../../utils/format";

const Clients = () => {

    const navigate = useNavigate();

    const dispatch = useAppDispatch();

    const clients = useAppSelector(getClientList);

    useEffect( () => {
        dispatch(fetchClientsByOrganization())
    }, [dispatch]);

    const iconByWallet = ( walletName: string ) => {
        switch( walletName ) {
            case 'BRL': 
                return <span className="wallet-icon">R$</span>;
            case 'USDT': 
                return <span className="wallet-icon">₮</span>;
            case 'BTC': 
                return <span className="wallet-icon">
                    <Bitcoin size={16} />
                </span>;
            case 'TRX':
                return <span className="wallet-icon">
                    <svg viewBox="0 0 256 256" aria-hidden="true">
                        <path fill="currentColor" d="M249.6 38.4L139.7 7.3a14.6 14.6 0 0 0-8.6 0L21.3 38.4a14.7 14.7 0 0 0-9.6 18.5l102.4 185.6a14.7 14.7 0 0 0 25.8 0L240.2 56.9a14.7 14.7 0 0 0-9.6-18.5zM128 24.2l92.7 26.2-84.4 15.7L128 24.2zm-9.6 46.7L36.7 54.9l79.6 16zM41.6 70.9l76.9 135.6L19.8 67.4zm95.9 135.6L214.4 70.9l21.8-3.5z"/>
                    </svg>
                </span>;
            case 'ETH':
                return <span className="wallet-icon">
                    <svg viewBox="0 0 256 417" aria-hidden="true">
                        <path fill="currentColor" d="M127.9 0L124.1 13.1V279.6L127.9 283.4L255.8 210.9z"/>
                        <path fill="currentColor" d="M127.9 0L0 210.9L127.9 283.4V150.9z"/>
                        <path fill="currentColor" d="M127.9 306.4L125.8 308.9V412.4L127.9 416.8L255.9 233.6z"/>
                        <path fill="currentColor" d="M127.9 416.8V306.4L0 233.6z"/>
                    </svg>
                </span>;
            default:
                return <span className="wallet-icon">
                    <Wallet size={16} />
                </span>;
        }
    };

    const goToUrl = (url:string) => {
        navigate('/clients/'+url);
    }

    return (
        <div className="client-wrapper">
            
            <h1 className="page-title">
                <div className="text">
                    Lista de Clientes
                    <small>lista de clientes cadastrados e suas respectivas informações, carteiras e seus valores.</small>
                </div>
            </h1>

            <hr />

            { clients && clients.length > 0 && (
                <>
                    <CardListHorizontal items={clients} showWalletCount />
                </> 
            )}
            { (!clients || clients.length === 0) && <h3 className="alert alert-nodata">Sem clientes para esse organizacao</h3> }
            
            
        </div>
    );
}

export default Clients;